import { ErrorLogComponent } from '@cian/error-log-component';

import { Children, type FC, type JSX } from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';

import styles from './ContentWrapper.css';

interface IContentWrapperProps {
  children: (JSX.Element | null)[];
}

export const ContentWrapper: FC<IContentWrapperProps> = ({ children }) => {
  const { logger } = useApplicationContext();

  return (
    <div className={styles['wrapper']}>
      {Children.map(children, child => (child ? <ErrorLogComponent logger={logger}>{child}</ErrorLogComponent> : null))}
    </div>
  );
};
